import { useExamContext } from "@features/exam/contexts/ExamContext";
/* -----------------Third parties--------------- */
import ChooseTestDataScreen from "../components/onboarding/OnboardingTestDate";
import type { HandleUpdateProgressHandler, NextButtonHandler } from "../types";

type Props = {
	handleNextAction: NextButtonHandler;
	cta?: string;
	handleUpdateProgress: HandleUpdateProgressHandler;
};

export const ChooseExamDateContainer = ({
	handleNextAction,
	cta,
	handleUpdateProgress,
}: Props) => {
	const {
		currentExamContext: { examDate },
		updateExamDate,
	} = useExamContext();

	const handleNext = () => {
		handleNextAction("home");
	};

	return (
		<ChooseTestDataScreen
			handleNext={handleNext}
			cta={cta}
			testDate={examDate}
			onDateChange={(date) => {
				handleUpdateProgress("increment");
				updateExamDate(date);
			}}
		/>
	);
};
